import { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useMainContext } from "../../hooks/useMainContext";
import { staleMessage } from "../../hooks/baseVersion";
import styles from "./styles.module.scss";

// The warning of a page that writes at once (useBaseVersion) when the row
// it edits was saved, or deleted, by a colleague under its unsaved edits:
// the edits stay, a Save is refused; Reload (confirmed) discards them and
// shows the stored row. stale: useBaseVersion's; onReload: its reload.
export default function ColleagueSaved({ stale, onReload, className = "" }) {
  const { requestConfirm, createNotification } = useMainContext();
  const [busy, setBusy] = useState(false);

  if (!stale) return null;

  const reload = () =>
    requestConfirm(
      stale.deleted
        ? "Discard your changes? The item is not stored any more."
        : "Discard your changes and show the version stored now?",
      () => {
        setBusy(true);
        Promise.resolve(onReload())
          .catch((error) =>
            createNotification("error", String(error?.message ?? error))
          )
          .finally(() => setBusy(false));
      }
    );

  return (
    <span className={`${styles.colleagueSaved} ${className}`} role="alert">
      <FontAwesomeIcon icon={faExclamationTriangle} className={styles.icon} />
      {staleMessage(stale)}: your Save will be refused.{" "}
      {stale.deleted
        ? "Reload to discard your changes."
        : "Reload to see their version."}
      <Button
        size="sm"
        variant="outline-warning"
        onClick={reload}
        disabled={busy}
      >
        Reload
      </Button>
    </span>
  );
}
